export const BENEFICIARY_CSV_IMPORT_COLUMNS = [
  'sieId',
  'ide',
  'firstName',
  'lastName',
  'programTitle',
  'email',
  'organizationName',
  'organizationSieId',
  'agencyName',
  'agencySieId',
  'orderLetter',
  'phoneNumber',
  'firstAppointmentDate',
  'firstAppointmentTime',
  'firstAppointmentModality',
  'firstAppointmentAddress',
  'firstAppointmentAddress2',
  'firstAppointmentZipCode',
  'firstAppointmentCity',
  'marketCode',
  'externalId',
] as const;

export type BeneficiaryCsvImportColumn = (typeof BENEFICIARY_CSV_IMPORT_COLUMNS)[number];
